export const meta = {
  id: 'comb-sort',
  name: 'Comb Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²)',
    space: 'O(1)'
  },
  description: 'Comb Sort is an improvement over Bubble Sort that uses a shrinking gap between compared elements to eliminate small values near the end (turtles) quickly.'
};
